/**
 * Scroll reveal — fades elements in as they enter the viewport.
 *
 * Elements are marked `.reveal` in the template and are visible by default in
 * CSS if this never runs, so a JS failure degrades to "everything shown"
 * rather than a blank page.
 */

export default function reveal() {
  const items = document.querySelectorAll('.reveal');
  if (!items.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduce) {
    items.forEach((el) => el.classList.add('is-in'));
    return;
  }

  // Positive bottom margin, so the root extends past the fold and an element
  // starts fading in before it is on screen rather than after. A tall band —
  // the facts grid, a two-column section — is taller than the space below the
  // fold, so waiting for it to actually enter meant scrolling a long way into
  // blank colour before anything appeared.
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px 18% 0px', threshold: 0 });

  items.forEach((el, i) => {
    // Stagger within a row of three without needing per-element markup.
    el.style.transitionDelay = `${(i % 3) * 80}ms`;
    io.observe(el);
  });
}
